import { useQuery } from '@tanstack/react-query';
import { useAuth0 } from '@auth0/auth0-react';
import { getJobCostSummaries, getJobCostDetails } from '../services/pricing.service';

// Hook to fetch job cost summaries
export const useJobCostSummaries = (options?: { enabled?: boolean }) => {
  const { getAccessTokenSilently } = useAuth0();
  const enabled = options?.enabled ?? true;

  return useQuery({
    queryKey: ['jobCostSummaries'],
    queryFn: async () => {
      const accessToken = await getAccessTokenSilently();
      const response = await getJobCostSummaries(accessToken);
      if (response.error) {
        throw new Error(response.error);
      }
      if (!response.data) {
        throw new Error('No data returned from API');
      }
      return response.data;
    },
    enabled,
    staleTime: 5 * 60 * 1000,
  });
};

// Hook to fetch job cost details for a specific job
export const useJobCostDetails = (jobId: string | null, options?: { enabled?: boolean }) => {
  const { getAccessTokenSilently } = useAuth0();
  const enabled = !!jobId && (options?.enabled ?? true);

  return useQuery({
    queryKey: ['jobCostDetails', jobId],
    queryFn: async () => {
      if (!jobId) return null;
      const accessToken = await getAccessTokenSilently();
      const response = await getJobCostDetails(accessToken, jobId);
      if (response.error) {
        throw new Error(response.error);
      }
      if (!response.data) {
        throw new Error('No cost data returned from API for this job.');
      }
      return response.data;
    },
    enabled,
    retry: 1,
    staleTime: 2 * 60 * 1000,
  });
}; 